import { QueryClientProvider } from '@tanstack/react-query';

import { queryClient } from './query-client';

type QueryProviderProps = {
  children: React.ReactNode;
};

export const QueryProvider = (props: QueryProviderProps) => {
  const { children } = props;

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};
